import { AuthLayout, DefaultLayout, SinglePageLayout } from '@/components/layouts'

export const publicRoute = [
  {
    path: '*',
    component: () =>
      import(/* webpackChunkName: "errors-404" */ '@/views/error/NotFound.vue'),
  },
  {
    path: '/auth',
    component: AuthLayout,
    meta: {
      title: 'Dr. Logic Login',
    },
    redirect: '/auth/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        meta: {
          title: 'Dr. Logic Login',
        },
        component: () =>
          import(/* webpackChunkName: "login" */ '@/views/auth/Login.vue'),
      },
    ],
  },

  {
    path: '/404',
    name: '404',
    meta: {
      title: 'Not Found',
    },
    component: () =>
      import(/* webpackChunkName: "errors-404" */ '@/views/error/NotFound.vue'),
  },

  {
    path: '/500',
    name: '500',
    meta: {
      title: 'Server Error',
    },
    component: () =>
      import(/* webpackChunkName: "errors-500" */ '@/views/error/Error.vue'),
  },
  {
    path: '/go/:uuid',
    name: 'svc-pw-decrypt',
    meta: {
      title: 'Secure Share',
      hiddenInMenu: true,
      disableCrumb: true,
    },
    component: () =>
      import(/* webpackChunkName: "svc-decrypt" */ '@/views/pw-sharing/Decrypt.vue'),
  },
]

export const protectedRoute = [
  //list
  {
    path: '/',
    component: DefaultLayout,
    meta: {
      title: 'Dr. Logic Apps',
      icon: 'view_compact',
      group: 'drlogic',
    },
    children: [
      {
        path: '/',
        name: 'svc-pw-list',
        meta: {
          title: 'Secure Share',
          requiresAuth: true,
        },
        component: () =>
          import(/* webpackChunkName: "table" */ '@/views/pw-sharing/Table.vue'),
      },
    ],
  },
]
